import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Button, Row, Col, Card, CardBody, FormGroup, Label } from "reactstrap";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone";
import ShowCard from "./ShowCard";
import { useFormik } from "formik";
import CustomInput from "../../../Components/Common/CustomInput/CustomInput";
import axios from "axios";
import toast from "react-hot-toast";
import Select from "react-select";
import DocumentServices from "../../../services/COOPServices/DocumentServices";
import DocumentFormValidation from "../../../validation/DocumentFormValidation";
import CustomSelect from "../../../Components/Common/CustomSelect/CustomSelect";

const Form = ({ onClose, data, setData, fetchData }) => {
  const navigate = useNavigate();
  const userString = localStorage.getItem("user");

  const user = JSON.parse(userString);

  const accessToken = user.accessToken;

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [categoryId, setCategoryId] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  // Function to toggle the modal
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const formik = useFormik({
    initialValues: {
      CooperativeId: 33,
      CategoryId: "",
      Title: "",
      Category: [],
      file: "",
      Description: "",
    },
    validationSchema: DocumentFormValidation,
    onSubmit: async (values) => {
      console.log("category", formik.values);
      try {
        console.log("Submitting doc form with values:", values);

        // Create new document
        await axios.post(`http://api.dsccou.sebs.asia/api/documents`, values, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        toast.success("Document Created Successfully!");
        fetchData();
        // setData([...data, values]);
        onClose();
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });

  const handleAcceptedFiles = (files) => {
    const formattedFiles = files.map((file) => ({
      name: file.name,
      path: file.path,
      preview: URL.createObjectURL(file),
    }));
    setSelectedFiles(formattedFiles);
    formik.setFieldValue("file", files[0]);
  };

  const handleFileRemove = (index) => {
    const files = [...selectedFiles];
    files.splice(index, 1);
    setSelectedFiles(files);

    if (formik.values.file && files.length === 0) {
      formik.setFieldValue("file", "");
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await DocumentServices.getlist();
        setCategoryId(response);
      } catch (error) {
        console.log("🚀 ~ async ~ error:", error);
      }
    })();
  }, []);

  const options = categoryId.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    formik.setFieldValue(
      "CategoryId",
      selectedOption ? selectedOption.value : ""
    );
  };

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <Card className="pt-1">
          <CardBody>
            <Row>
              <Col lg={8}>
                <Row>
                  <Col lg={12}>
                    <Dropzone onDrop={handleAcceptedFiles}>
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone dz-clickable pt-4">
                          <div
                            className="dz-message needsclick mb-5 p-3"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <i className=" align-item-center display-4 text-muted ri-upload-cloud-2-fill" />
                            <h4 className="fs-15 fw-semi-bold pt-3">
                              Drop files here or{" "}
                              <Link to="#">click to upload.</Link>
                            </h4>
                            <h4 className="fs-14 text-muted ">
                              Max Upload Size 10MB.
                            </h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="list-unstyled mb-0" id="file-previews">
                      {selectedFiles.map((f, i) => (
                        <Card
                          className=" mb-0  shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                          key={i + "-file"}
                        >
                          <div>
                            <Row className="align-items-center">
                              <Col className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="100"
                                  className="avatar-sm rounded bg-light"
                                  alt={f.name}
                                  src={f.preview}
                                />
                              </Col>
                              <Col>
                                <Link
                                  to="#"
                                  className="text-muted font-weight-bold"
                                >
                                  {f.name}
                                </Link>
                                <p className="mb-0">
                                  <strong>{f.formattedSize}</strong>
                                </p>
                              </Col>
                              <Col lg={2}>
                                <Link onClick={() => handleFileRemove(i)}>
                                  <h3>
                                    <i className="ri-delete-bin-2-line text-danger"></i>
                                  </h3>
                                </Link>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      ))}
                    </div>
                    {formik.errors.file && formik.touched.file && (
                      <div className="text-danger">{formik.errors.file}</div>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col lg={4}>
                <FormGroup>
                  <CustomInput
                    required
                    label={"Title"}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    id={"Title"}
                    name={"Title"}
                    placeholder={"Enter Title"}
                    value={formik.values.Title}
                    error={formik.errors.Title}
                    touched={formik.touched.Title}
                  />
                </FormGroup>

                <FormGroup>
                  {/* <Label>Category</Label> */}
                  <CustomSelect
                    required
                    label={"Category"}
                    name="Category"
                    onChange={handleChange}
                    options={options}
                    placeholder="Select Category"
                    value={selectedOption}
                    errors={formik.errors.CategoryId}
                    touched={formik.touched.CategoryId}
                    setFieldTouched={formik.setFieldTouched}
                    handleBlur={formik.handleBlur}
                    isClearable
                  />
                  {/* {formik.errors.CategoryId && formik.touched.CategoryId && (
                    <small className="text-danger">
                      {formik.errors.CategoryId}
                    </small>
                  )} */}
                </FormGroup>

                <FormGroup>
                  <CustomInput
                    required
                    type={"textarea"}
                    rows={4}
                    // cols={80}
                    label={"Description"}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    id={"Description"}
                    name={"Description"}
                    placeholder={"Enter Description"}
                    value={formik.values.Description}
                    error={formik.errors.Description}
                    touched={formik.touched.Description}
                  />
                </FormGroup>

                <div className="d-grid">
                  <Button
                    type="submit"
                    className="btn-success mt-2 mb-2"
                    // onClick={handlePublish}
                  >
                    Publish
                  </Button>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </form>

      <ShowCard isOpen={modalOpen} toggle={toggleModal} />
    </div>
  );
};

export default Form;
